export const DATA_KEY = 'data-key'

export const MIN_MOUSE_MOVE = 10
